import { ReactNode } from 'react';
import { Alert, AlertIcon, AlertProps, Box } from '@chakra-ui/react';

type TDisclamerProps = {
    status: 'success' | 'warning' | 'error' | 'info';
    body: ReactNode;
};

const Disclamer = ({ status, body, ...props }: AlertProps & TDisclamerProps) => (
    <Box {...props}>
        <Alert status={status} p={2} borderRadius={10}>
            <AlertIcon />
            {body}
        </Alert>
    </Box>
);
export default Disclamer;
